import { getMetadata, getStreams, getAudioDescriptionUrl, getDownloads, getCaptions, getChapters, getHotspots, getTimedEvents, getCompositionMap, getCompositionList, getPresentationOptions } from '../../../api/presentation';
import { getOptions, getExtensions } from '../../../api/player';

/**
 * @param {string} presentationId
 * @returns {Promise<PresentationData>}
 */
export async function loadPresentationData(presentationId) {
    const [
        metadata,
        streams,
        audioDescriptionUrl,
        downloads,
        captions,
        chapters,
        hotspots,
        timedEvents,
        playerOptions,
        playerExtensions,
        compositionMap,
        compositionList,
        presentationOptions
    ] = await Promise.all([
        getMetadata(presentationId),
        getStreams(presentationId),
        getAudioDescriptionUrl(presentationId),
        getDownloads(presentationId),
        getCaptions(presentationId),
        getChapters(presentationId),
        getHotspots(presentationId),
        getTimedEvents(presentationId),
        getOptions(presentationId),
        getExtensions(presentationId),
        getCompositionMap(presentationId),
        getCompositionList(presentationId),
        getPresentationOptions(presentationId)
    ]);

    return {
        metadata,
        streams,
        audioDescriptionUrl,
        downloads,
        captions,
        chapters,
        hotspots,
        timedEvents,
        playerOptions,
        playerExtensions,
        compositionMap,
        compositionList,
        presentationOptions
    }
}
